<template>
  <div >
    <div class="ht60"></div>
    <div class="indexTitle">请选择你的身份</div>
    <div class="ht30"></div>
    <div class="ht15"></div>
    <div style="width: 99vw;">
      <div @click="click(2)" class="indexCard" :class="active === 2 ? 'active':''">
        <div>
          <img src="../../assets/worker.png" class="indexImg">
        </div>
        <div>我是工作人员</div>
        <div class="indexCorner" v-if="active === 2">
        </div>
        <div class="indexZw" v-else></div>
      </div>
      <van-icon name="success" color="white" size="3.2vw" class="indexIcon"  v-show="active === 2"/>
      <div class="indexIconB" v-show="active!==2"></div>
      <div @click="click(3)" class="indexCard" :class="active === 3 ? 'active':''">
        <div>
          <img src="../../assets/user.png" class="indexImg">
        </div>
        <div style="flex: 1">我要年审</div>
        <div class="indexCorner" v-if="active === 3">
        </div>
        <div class="indexZw" v-else></div>
      </div>
      <van-icon name="success" color="white" size="3.2vw" class="indexIcon"  v-show="active === 3"/>
      <div class="indexIconB" v-show="active!==3"></div>

    </div>
    <div class="ht90"></div>
    <div class="fsac">
      <van-button @click="goto" type="info" style="width: 60vw" round :disabled="!active">确定</van-button>
    </div>
  </div>
</template>

<script>
import { Loading, Button, Icon } from 'vant';
// import axios from 'axios'
export default {
  mounted () {
    this.active = 0
  },
  components: {
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  data() {
    return { 
      active: 0,
    }
  },
  methods: {
    goto () {
      this.$router.push({path: '/login', query: {utype: this.active} })
    },
    click (index) {
      this.active = index
    },
    async getCode2 () {
      let {data} = await this.$api.wxLogin({sUrl: this.rdi_url})
      window.location.href = data
      // console.log(data)
    }
  }
};
</script>

<style>
.indexCard {
  display: flex;
  justify-content: space-between;
  margin: 20px;
  margin-bottom: -10px;
  height: 130px;
  text-align: center;
  line-height: 130px;
  color: #444;
  font-size: 20px;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 5px;
  z-index: 0;
  overflow:hidden;
}
.indexCard:active {
  color: rgba(31,130,255, 0.9)  !important;
  background: rgba(31,130,255, 0.08) !important;
  border: 1px solid rgba(31,130,255, 0.5) !important;
}
.indexCard.active {
  color: rgba(31,130,255, 0.9)  !important;
  background: rgba(31,130,255, 0.08) !important;
  border: 1px solid rgba(31,130,255, 0.5) !important;
}
.indexImg {
  margin-top: 10px;
  margin-right: 10px;
  width: 120px;
  height: 120px;
}
.indexTitle {
  font-size: 28px;
  font-weight: bold;
  margin: 20px;
  height: 40px;
  line-height: 40px;
}
.indexCorner {
  /* overflow:hidden; */
  background: #1F82FF;
  color: #fff;
  width: 30px;
  height: 30px;
  transform: rotate(45deg);
  position: relative;
  top: 115px;
  left: 15px;
  z-index: 1;
}
.indexZw {
  background: transparent;
  color: #fff;
  width: 30px;
  height: 30px;
}
.indexIconB {
  width: 20px;
  height: 22px;
}
.indexIcon {
  width: 20px;
  height: 20px;
  top: -6px;
  /* position: absolute; */
  left: 338px;
  /* right: 20px; */
  z-index: 2;
}
</style>
